import React from 'react'
import get from 'lodash/get'

const withCta = (WrappedComponent) => {
  const Wrapper = (props) => {
    const getCtaParams = () => {
      return {
        cta: { area: props.area, label: props.config.text },
        type: props.config.type,
        form_id: get(props.config.metadata, 'form_id'),
        invitation_id: get(props.config, ['send_mail', 'invitation_id']),
        inviter_id: get(props.config, ['send_mail', 'sender', 'id']),
        item_id: !!props.itemId ? props.itemId : null
      }
    }

    return (
      <WrappedComponent
        getCtaParams={getCtaParams}
        {...props} />
    )
  }

  return Wrapper
}

export default withCta